import * as React from "react";
import { useState, FunctionComponent } from "react";
import { styled, Block } from "../../../seenspire-library";
import { OverlayDirection } from "./interfaces";
import { useVideo } from "react-use";
import PlayPauseIcon from "./PlayPauseIcon";
import fullScreenIcon from "../../../assets/fullScreenIcon.svg";

const AsyncVideoStyled = styled.div.attrs({})<{ loaded: boolean }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1;
  opacity: ${({ loaded }) => (loaded ? 1 : 0)};
  overflow: hidden;
  transition: all 500ms ease;
  display: grid;
  align-items: center;
  justify-items: center;
`;

const VideoStyled = styled.video`
  position: absolute;
  width: 100%;
  height: 100%;
  /* object-fit: cover; */
`;

const PlayIconsContainer = styled(Block)`
  top: 0;
  left: 0;
  width: 70px;
  height: 70px;
  z-index: 1000;
`;

const FullScreenIconContainer = styled(Block)`
  position: absolute;
  bottom: 0;
  right: 5px;
  z-index: 1000;
`;

const AsyncVideo: FunctionComponent<{
  src: any;
  poster?: any;
  isActive?: boolean;
  skipOverlay?: boolean;
  overlayDirection?: OverlayDirection;
  withContainer?: boolean;
  style?: any;
  autoPlay?: boolean;
  onMediaPreview?: () => void;
  visibleIcon?: boolean;
  videoClass?: string;
}> = ({
  src,
  poster,
  isActive,
  skipOverlay,
  overlayDirection,
  withContainer,
  onMediaPreview,
  autoPlay,
  visibleIcon,
  videoClass,
  ...props
}) => {
  const [showControls] = useState(!withContainer);
  const [showIcons, setShowIcons] = useState(!!visibleIcon);
  const [video, state , controls] = useVideo(
    <VideoStyled
      src={src}
      controls={showControls}
      poster={poster}
      autoPlay={autoPlay}
      className={videoClass}
      {...props}
    />
  );
  React.useEffect(() => {
    setShowIcons(!!visibleIcon);
  }, [visibleIcon]);

  return withContainer ? (
    <AsyncVideoStyled
      loaded={true}
      onMouseOver={() => setShowIcons(true)}
      onMouseLeave={() => setShowIcons(false)}
    >
      {showIcons && (
        <PlayIconsContainer>
          <PlayPauseIcon showIcons={showIcons} controls={controls} isPaused={state.paused} />
        </PlayIconsContainer>
      )}
      {onMediaPreview && (
        <FullScreenIconContainer
          opacity={showIcons ? 1 : 0}
          transition
          onClick={() => {
            controls.pause();
            onMediaPreview();
          }}
        >
          <img style={{ width: 35, height: 35 }} src={fullScreenIcon} />
        </FullScreenIconContainer>
      )}
      {video}
    </AsyncVideoStyled>
  ) : (
    video
  );
};
export default AsyncVideo;
